import { render } from "./navFooter.vue?vue&type=template&id=a6ece5c4"
import script from "./navFooter.vue?vue&type=script&lang=js"
export * from "./navFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__